import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import ApplyForm from './ApplyForm'
import { useSelector } from 'react-redux'

function CreateApplication({ showModal, setShowModal }) {
  const { errorMessage } = useSelector((store) => store.recruitment)

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        Create New Job Application
      </ModalHeader>
      <ModalBody className='scrollbar'>
        {errorMessage && (
          <div class='alert alert-danger' role='alert'>
            {errorMessage}
          </div>
        )}
        <ApplyForm onSuccessFn={() => setShowModal(false)} />
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton form='application'></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateApplication
